import questionAnswersListTemplate from './question_answers_list.template.html';

angular.module('westBerkshireEvents.questionAnswersList').component('wbQuestionAnswersList', {
    templateUrl: questionAnswersListTemplate.id,
    controller: ['$scope', WbQuestionAnswersListController],
    controllerAs: "$questionAnswersListCtrl",
    bindings: {
        booking: '<'
    }
});

function WbQuestionAnswersListController($scope) {
    const self = this;

    this.booking.$getAnswers().then(result => {
        self.answers = result.answers;
        result.answers.forEach(answer => {
            answer.getQuestion().then(question => {
                console.log(question);
                // Populate the question on the answer
                answer.question = question;
            });
        });
    });
}



// WEBPACK FOOTER //
// src/public/javascripts/question-answers-list/question_answers_list.component.js